module.exports = __webpack_public_path__ + "static/logo-4328160af0e14479616ebe81f43c0656.png";